import { firebaseConfig } from "/src/firebaseConfig.js";
import { getDatabase, ref, get, set } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { reaction } from "mobx";

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

export function syncUser(model) {
    onAuthStateChanged(auth, (user) => {
        if (user) {
            const userId = user.uid;
            model.setIsLoggedIn(true);
            readFromFirebase(model, userId).then(() => {
                observeFavorites(model, userId);
            });
        } else {
            console.log("No user is signed in.");
            model.setIsLoggedIn(false);
        }
    });
}

export function modelToPersistence(model) {
    return {
        favorites: model.favorites
    }
}

export function persistenceToModel(data, model) {
    if (!data || !data.favorites) {
        model.favorites = { 
            paintings: [], 
            artists: [] 
        };
        return;
    }

    model.favorites = {
        paintings: Array.isArray(data.favorites.paintings) ? [...data.favorites.paintings] : [],
        artists: Array.isArray(data.favorites.artists) ? [...data.favorites.artists] : []
    };
}


export function saveToFirebase(model, userId) {
    const userRef = ref(db, `users/${userId}`);
    const data = modelToPersistence(model);

    set(userRef, data);
}

export function readFromFirebase(model, userId) {
    model.loading = true;
    const userRef = ref(db, `users/${userId}`);

    return get(userRef).then((snapshot) => persistenceToModel(snapshot.val(), model)).then(() => model.loading = false).catch((error) => console.error("Error reading from Firebase:", error));
}

export function observeFavorites(model, userId) {
    reaction(
        () => model.favorites, 
        (favorites) => {
            if (userId) {
                saveToFirebase(model, userId);
            }
        },
        { fireImmediately: true }
    );
}
